/**
 * 存储工具：仅使用 localStorage
 */

/**
 * 存储数据
 * @param {string} key
 * @param {string} value
 */
export function setStorage(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    console.warn("setStorage failed:", e);
  }
}

/**
 * 读取数据
 * @param {string} key
 * @returns {string}
 */
export function getStorage(key) {
  try {
    return localStorage.getItem(key) || "";
  } catch (e) {
    console.warn("getStorage failed:", e);
    return "";
  }
}

/**
 * 删除数据
 * @param {string} key
 */
export function removeStorage(key) {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    console.warn("removeStorage failed:", e);
  }
}

/**
 * 清空指定存储
 * @param {string[]} keys
 */
export function clearStorage(keys) {
  keys.forEach((key) => {
    removeStorage(key);
  });
}
